/* __next_internal_client_entry_do_not_use__ SDUIButtonRenderer auto */ import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { extractLinkFromActions } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/extractLinkFromActions";
import { useSDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/useSDUIOnClickHandler";
import { getSlateButtonVariant } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/getSlateButtonVariant";
import { Button } from "@faire/web--source/slate/Button/Button";
import { IconButton } from "@faire/web--source/slate/IconButton";
import { getSlateIcon } from "@faire/web--source/slate/SlateMappings/getSlateIcon";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import classNames from "classnames";
import React from "react";
import { assignInlineVars } from "@faire/retailer-visitor-shared/lib/tailwindUtils";
var varColor = {
    variable: "--f-sdui-button-color",
    className: "!text-[--f-sdui-button-color]"
};
var varBackgroundColor = {
    variable: "--f-sdui-button-bg",
    className: "!bg-[--f-sdui-button-bg]"
};
var varColorDivChild = {
    variable: "--f-sdui-button-color",
    className: "[&>div]:text-[--f-sdui-button-color]"
};
var varBackgroundColorDivChild = {
    variable: "--f-sdui-button-bg",
    className: "[&>div]:bg-[--f-sdui-button-bg]"
};
export var SDUIButtonRenderer = function(param) {
    var buttonElement = param.buttonElement, loggingData = param.loggingData, className = param.className, fireLegacyOnClickEvent = param.fireLegacyOnClickEvent, onClickClientDismissHandler = param.onClickClientDismissHandler;
    var _icon_and_text_icon;
    var icon = buttonElement.icon, text = buttonElement.text, icon_and_text = buttonElement.icon_and_text, variant = buttonElement.variant, on_click = buttonElement.on_click, style_override = buttonElement.style_override;
    var _extractLinkFromActions = extractLinkFromActions(on_click !== null && on_click !== void 0 ? on_click : []), link = _extractLinkFromActions.link, newTabLink = _extractLinkFromActions.newTabLink, nonNavigationActions = _extractLinkFromActions.nonNavigationActions;
    var onClickHandler = useSDUIOnClickHandler(nonNavigationActions, loggingData, {
        logSDUIClickEvent: true,
        logLegacyClickEvent: fireLegacyOnClickEvent
    });
    var onClickWithLinkHandler = useSDUIOnClickHandler(on_click, loggingData, {
        logSDUIClickEvent: true,
        logLegacyClickEvent: fireLegacyOnClickEvent
    });
    var isConductorComponent = nonNavigationActions.some(function(action) {
        var _action_dismiss;
        return (_action_dismiss = action.dismiss) === null || _action_dismiss === void 0 ? void 0 : _action_dismiss.conductor_component_token;
    });
    if (icon) {
        var SlateIcon = getSlateIcon(icon);
        var backgroundColor = style_override === null || style_override === void 0 ? void 0 : style_override.background_color;
        var _icon_color_token;
        var color = (_icon_color_token = icon.color_token) !== null && _icon_color_token !== void 0 ? _icon_color_token : style_override === null || style_override === void 0 ? void 0 : style_override.color;
        var _obj;
        return /*#__PURE__*/ _jsx(IconButton, {
            variant: getSlateButtonVariant(variant),
            onClick: function() {
                if (isConductorComponent) {
                    onClickClientDismissHandler === null || onClickClientDismissHandler === void 0 ? void 0 : onClickClientDismissHandler();
                }
                onClickWithLinkHandler();
            },
            "aria-label": text !== null && text !== void 0 ? text : "",
            className: classNames(backgroundColor || color ? varBackgroundColorDivChild.className + " " + varColorDivChild.className : undefined, className),
            style: assignInlineVars((_obj = {}, _define_property(_obj, varBackgroundColorDivChild.variable, getSlateColorToken(backgroundColor)), _define_property(_obj, varColorDivChild.variable, getSlateColorToken(color)), _obj)),
            children: /*#__PURE__*/ _jsx(SlateIcon, {
                color: getSlateColorToken(icon.color_token)
            })
        });
    }
    var IconComponent = getSlateIcon(icon_and_text === null || icon_and_text === void 0 ? void 0 : icon_and_text.icon);
    var _icon_and_text_text;
    var buttonText = (_icon_and_text_text = icon_and_text === null || icon_and_text === void 0 ? void 0 : icon_and_text.text) !== null && _icon_and_text_text !== void 0 ? _icon_and_text_text : text;
    var flexDirectionClassName = getIconPositionFlexDirection(icon_and_text === null || icon_and_text === void 0 ? void 0 : icon_and_text.icon_position) === "row-reverse" ? "flex-row-reverse" : "flex-row";
    var _obj1;
    return /*#__PURE__*/ _jsxs(Button, {
        variant: getSlateButtonVariant(variant),
        linkTo: newTabLink !== null && newTabLink !== void 0 ? newTabLink : link,
        target: newTabLink ? "_blank" : undefined,
        onClick: function() {
            if (isConductorComponent) {
                onClickClientDismissHandler === null || onClickClientDismissHandler === void 0 ? void 0 : onClickClientDismissHandler();
            }
            onClickHandler();
        },
        className: classNames(style_override ? varBackgroundColor.className + " " + varColor.className : undefined, (icon_and_text === null || icon_and_text === void 0 ? void 0 : icon_and_text.icon) ? "flex gap-x-2 " + flexDirectionClassName : undefined, className),
        style: assignInlineVars((_obj1 = {}, _define_property(_obj1, varBackgroundColor.variable, getSlateColorToken(style_override === null || style_override === void 0 ? void 0 : style_override.background_color)), _define_property(_obj1, varColor.variable, getSlateColorToken(style_override === null || style_override === void 0 ? void 0 : style_override.color)), _obj1)),
        children: [
            (icon_and_text === null || icon_and_text === void 0 ? void 0 : icon_and_text.icon) ? /*#__PURE__*/ _jsx(IconComponent, {
                color: getSlateColorToken(icon_and_text === null || icon_and_text === void 0 ? void 0 : (_icon_and_text_icon = icon_and_text.icon) === null || _icon_and_text_icon === void 0 ? void 0 : _icon_and_text_icon.color_token)
            }) : null,
            buttonText
        ]
    });
};
var getIconPositionFlexDirection = function(icon_position) {
    switch(icon_position){
        case IButtonElement.IFaireIconText.FaireIconPosition.END:
            return "row-reverse";
        case IButtonElement.IFaireIconText.FaireIconPosition.START:
        default:
            return "row";
    }
};
